import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMonitor",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--monitor"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Monitor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h8a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 2H2Zm4.5 7H10a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 10 1H2A1.5 1.5 0 0 0 .5 2.5v5A1.5 1.5 0 0 0 2 9h3.5v1H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.5V9Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=monitor.js.map
